import { Text } from '@vkontakte/vkui';
import React, { memo, useEffect } from 'react';
import { cdnPackagesUrl } from 'reactApp/appHelpers/themeToolHelpers/default-values';
import { sendDwh } from 'reactApp/utils/ga';
import opener from 'reactApp/utils/opener';

import styles from './SummerSaleSidebarBanner.css';

const PROMO_ID = 'summer-sale-2026';

const onClick = () => {
    sendDwh({ eventCategory: 'banner', action: 'click', dwh_enabled: true, dwhData: { name: PROMO_ID } });
    opener('/promo/quota', true);
};

export const SummerSaleSidebarBanner = memo(() => {
    useEffect(() => {
        sendDwh({ eventCategory: 'banner', action: 'show', dwh_enabled: true, dwhData: { name: PROMO_ID } });
    }, []);

    return (
        <div className={styles.root} onClick={onClick}>
            <Text className={styles.text}>Призы и место для фото</Text>
            <img className={styles.image} src={`${cdnPackagesUrl}/static/cloud/promo/summerSale2026/sidebarBannerImage.png`} />
        </div>
    );
});

SummerSaleSidebarBanner.displayName = 'SummerSaleSidebarBanner';
